"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalTitle = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _ModalNav = require("./ModalNav");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ModalTitle = exports.ModalTitle = function ModalTitle(_ref) {
  var title = _ref.title,
    stepName = _ref.stepName,
    steps = _ref.steps,
    goToStep = _ref.goToStep;
  if (stepName === "connect") {
    return /*#__PURE__*/_react.default.createElement(_Box.default, {
      sx: {
        marginLeft: "auto",
        marginRight: "auto"
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      sx: {
        fontWeight: "700"
      },
      variant: "h4"
    }, title));
  }
  if (stepName === "confirm") {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  return /*#__PURE__*/_react.default.createElement(_Box.default, null, /*#__PURE__*/_react.default.createElement(_ModalNav.ModalNav, {
    steps: steps,
    stepName: stepName,
    goToStep: goToStep
  }));
};